import React from 'react'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { selectUserData } from '../../reducers/userDataReducer'
import { getTimezoneShortName, getBuildingTimezoneFromEvent } from '../../helpers/helpers'
import { WeekAndDayTimeBlock } from './TimeBlocks/WeekAndDayTimeBlock'

class DayEvent extends React.Component {
  render() {
    const { type, start, title, canceled, buildingId, reservationType } = this.props.event
    const buildingName = buildingId ? buildingId.name || buildingId.text : ''
    const isAppointment = type ? type.personal : false
    const role = this.props.userData.user ? this.props.userData.user.role : null
    const timezone = getBuildingTimezoneFromEvent(this.props.event)
    const isCompleted = moment().tz(timezone).isAfter(moment(start).tz(timezone, true))
    let eventClass = `ctp-event ctp-event--day`
    if (isCompleted || canceled) {
      eventClass += ' ctp-event--archive'
    }

    const isTimeBlock = reservationType === 'timeBlock'

    if (isTimeBlock) {
      return <WeekAndDayTimeBlock timeBlock={this.props.event} />
    }

    return (
      <div className={eventClass}>
        <div
          className="ctp-event__overlay"
          style={{ backgroundColor: type ? type.color : 'black' }}
        />
        <div className="ctp-event__inner">
          <div className="ctp-event__title">
            {role !== 'Client' ? `(${getTimezoneShortName(timezone)}) ` : null}
            {isAppointment || role === 'Client' || role === 'PropertyManager'
              ? title
              : `${buildingName} - ${title}`}
          </div>
        </div>
      </div>
    )
  }
}

DayEvent.propTypes = {
  event: PropTypes.object,
  userData: PropTypes.object,
}

export default connect((state) => ({ userData: selectUserData(state) }))(DayEvent)
